import 'es6-object-assign/auto';
import $ from 'jquery';

import './c-card-filter.scss';
import { i18n } from '../../translation.js';
import template from './card-filter.vhtml';
import QdToggle from '../toggle-stateless/toggle-stateless.js';
import QdToggleTrueFalse from '../toggle-true-false-stateless/toggle-true-false-stateless.js';
import { historyComponentMixin } from '../../plugins/history';

export default {
	template,
	mixins: [ historyComponentMixin ],
	components: {
		QdToggle,
		QdToggleTrueFalse,
	},
	props: {
		filterSetup: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			displayedFilters: [],
			hiddenFilters: [],
			selections: {},
			isOpen: false,
			placeholder: i18n.t( 'search' ) + '...',
		};
	},
	computed: {
		moreFilters() {
			return ( !this.isOpen ) ? i18n.t( 'showMoreFilters' ) : i18n.t( 'hideAdditionalFilters' );
		},
	},
	created() {
		// Create default values for selections
		this.selections = this.filterSetup.filters.reduce( ( selections, filter ) => {
			selections[ filter.name ] = 'value' in filter ? filter[ 'value' ] : '';
			return selections;
		}, {});

		// Add selections from query Params
		this.selections = Object.assign({}, this.selections, this.history.queryParams );

		// Emit
		this.update();
	},
	mounted() {
		this.displayedFilters = Array.prototype.slice.call( this.filterSetup.filters, 0,  this.filterSetup.display );
		this.hiddenFilters = Array.prototype.slice.call( this.filterSetup.filters, this.filterSetup.display );
	},
	methods: {
		selectOption( name, value ) {
			let newValues = {};
			newValues[ name ] = value;
			this.selections = Object.assign({}, this.selections,  newValues );
			this.update();
		},	
		showMore() {
			if ( this.isOpen ) {
				$( '.c-card-filter__more-filters.js-slide-down-up' ).slideUp( 400 );
				this.isOpen = false;
			} else {
				$( '.c-card-filter__more-filters.js-slide-down-up' ).slideDown( 400 );
				this.isOpen = true;
			}
		},
		update() {
			// Only emit selected values
			const nonEmptySelections = Object.keys( this.selections )
				.filter( key => this.selections[ key ] !== '' )
				.reduce( ( selections, key ) => { selections[ key ] = this.selections[ key ]; return selections; }, {} );
			
			this.$emit( 'update-filters', nonEmptySelections );
			
			// Update url params
			Object.keys( this.selections ).forEach( name => {
				this.history.setQueryParam( name, this.selections[ name ]);
			});
		},
		createOptions( filter ) {
			return filter.options.map( option => ({ label: option.title, value: option.id }) );
		},
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/card-filter/card-filter.js